import { render, staticRenderFns } from "./EcoendoscopiaEdit.vue?vue&type=template&id=f790ecb4"
import script from "./EcoendoscopiaEdit.vue?vue&type=script&lang=js"
export * from "./EcoendoscopiaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports